import React, { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { Box, TextField, MenuItem } from "@mui/material";
import { DataTable } from "primereact/datatable";
import { Tooltip } from "primereact/tooltip";
import { Badge } from "primereact/badge";
import { Chart } from "primereact/chart";
import { Dialog } from "primereact/dialog";
import html2canvas from "html2canvas";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import * as Constants from "../../../constants";
import { useLocale } from "../../../locale";
import "./tables.scss";
const Table = (props) => {
  const { locale } = useLocale();
  const MAX_WORDS_PER_LABEL = 2;
  const [modal, setModal] = useState(false);
  const [report, setReport] = useState();
  const [highScales, setHighScales] = useState();
  const [lowScales, setLowScales] = useState();
  const [value, setValue] = useState();
  const [selectedUser, setSelectedusers] = useState([]);
  const [reportName, setReportName] = useState("");
  const [expandedRows, setExpandedRows] = useState([]);
  const [dataTableList, setDataTableList] = useState([]);
  const [coloumns, setColoumns] = useState([]);
  const [filters, setFilters] = useState([]);
  const [colors, setColors] = useState([]);
  const [chartData, setChartData] = useState([]);

  /**
   * ALL THE useEffect HOOKS ARE PLACED HERE
   */

  useEffect(() => {
    if (props.tabActiveKey === Constants.TAB_SALES_STRENGTHS_KEY) {
      setReportName("SalesStrengths");
      setReport("Sales Strength Report");
    }
    setColoumns(props.tableColoumns);
    covertToDataTable(props.dataTableList);
    if (!filters.length && props.tableColoumns) {
      setIntialFilters();
    }
    if (props.chartDialog) {
      customDataForChart();
    }
    // eslint-disable-next-line
  }, [props]);

  useEffect(() => {
    const url = "https://assistant-api.mazhr.com/client/v1/config";
    const fetchColors = async () => {
      try {
        const response = await fetch(url);
        const json = await response.json();
        setColors(json?.data?.colors_data_for_5);
      } catch (error) {
        console.log("error", error);
        setColors([
          { color: "#00B0A0", points_list: [1, 2, 3] },
          { color: "#FFBB31", points_list: [4, 5, 6] },
          { color: "#8049B0", points_list: [7, 8, 9] },
        ]);
      }
    };
    if (!colors.length) {
      fetchColors();
    } // eslint-disable-next-line
  }, [colors]);

  useEffect(() => {
    let labelLower = value?.toLowerCase();
    for (const propertyName in props?.scaleDescription) {
      const originalProperty = propertyName;
      const splitProperty = splitCamelCase(originalProperty);
      const lowerCaseProperty = splitProperty.toLowerCase();

      // Trim the strings to remove any leading or trailing spaces, accidentally added in Contentful or backend API
      if (lowerCaseProperty?.trim() === labelLower?.trim()) {
        setHighScales(props.scaleDescription[propertyName]?.high);
        setLowScales(props.scaleDescription[propertyName]?.low);
        break;
      } else {
        // If the label is not found, reset the high and low scales to avoid showing the previous values
        setHighScales(null);
        setLowScales(null);
      }
    }
  }, [value, props.scaleDescription]);

  /**
   * ALL THE UTILITY FUNCTIONS ARE PLACED HERE
   */

  function splitCamelCase(property) {
    return property.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase();
  }

  const getLabelIndex = (x, y, pointLabelsArray) => {
    let index = -1;
    for (let i = 0; i < pointLabelsArray.length; i++) {
      const { top, right, bottom, left } = pointLabelsArray[i];
      if (x >= left && x <= right && y >= top && y <= bottom) {
        index = i;
        break;
      }
    }
    return index;
  };
  const [lightOptions] = useState({
    onClick: (evt, activeEls, chart) => {
      const { x, y } = evt;
      let index = -1;

      for (let i = 0; i < chart.scales.r._pointLabelItems.length; i++) {
        const { bottom, top, left, right } = chart.scales.r._pointLabelItems[i];

        if (x >= left && x <= right && y >= top && y <= bottom) {
          index = i;
          break;
        }
      }

      if (index === -1) {
        return;
      }

      let clickedLabel = chart.scales.r._pointLabels[index];
      clickedLabel = clickedLabel?.join(" ");
      setValue(clickedLabel);
      setModal(true);
    },
    onHover: ({ x, y }, activeHover, chart) => {
      const { canvas } = chart;
      let index = getLabelIndex(x, y, chart.scales.r._pointLabelItems);
      if (index === -1) {
        canvas.style.cursor = "default";
        chart.update();
      } else {
        canvas.style.cursor = "pointer";
      }
    },
    plugins: {
      legend: {
        labels: {
          color: "#495057",
        },
      },
    },

    scales: {
      r: {
        max: 5,
        min: 0,
        ticks: {
          stepSize: 1,
        },
        pointLabels: {
          color: "#495057",
          font: 24,
        },
        grid: {
          color: "#ebedef",
        },
        angleLines: {
          color: "#ebedef",
        },
      },
    },
  });

  const customDataForChart = () => {
    let customColorArray = [
      { color: "#7900FF" },
      { color: "#9F6400" },
      { color: "#C13FA8" },
      { color: "#FFCC00" },
      { color: "#150941" },
      { color: "#00B2A0" },
      { color: "#AAAD00" },
      { color: "#F87000" },
      { color: "#FF66C4" },
      { color: "#2ECBDC" },
      { color: "#8D0404" },
      { color: "#004AAD" },
      { color: "#545454" },
      { color: "#548CFF" },
      { color: "#00BF63" },
    ];
    const labels = [];
    const allCol = props.tableColoumns || [];
    allCol?.forEach((col) => {
      labels.push(col.header_name);
    });
    const dataset = [];
    let chartDataObj = {};
    let userName = "";
    if (props?.selectedCol.toLowerCase() === "competency & attitude") {
      selectedUser.forEach((user, index) => {
        userName = user.user_name;
        const keys = Object.keys(user);
        keys.forEach((key, i) => {
          let nameLabel = "";
          let randomColor = "";
          let data = [];
          if (typeof user[`${key}`] === "object" && user[`${key}`]) {
            nameLabel = key.toUpperCase();
            const colKeys = Object.keys(user[`${key}`]);
            for (let j = 0; j < colKeys.length; j++) {
              if (
                typeof user[`${key}`][`${colKeys[j]}`] === "number" &&
                colKeys[j] !== "user_id"
              ) {
                data.push(user[`${key}`][`${colKeys[j]}`]);
              }
            }
            randomColor =
              "#" + Math.floor(Math.random() * 16777215).toString(16);
            randomColor = randomColor.replace(/[^0-9A-F]/gi, ""); // remove any non-hexadecimal characters
            if (randomColor.length < 6) {
              randomColor += "0".repeat(6 - randomColor.length); // add trailing zeros if necessary
            }
            randomColor = "#" + randomColor;
            dataset.push({
              label: nameLabel,
              data: data,
              borderColor: randomColor,
              pointHoverBackgroundColor: "#fff",
            });
          }
        });
      });
    } else {
      selectedUser.forEach((user, index) => {
        let data = [];
        let color;
        const nameLabel = user.user_name;
        const keys = Object.keys(user);
        keys.forEach((key, i) => {
          if (
            typeof user[`${key}`] === "object" &&
            key === props?.selectedCol.toLowerCase()
          ) {
            const colKeys = Object.keys(user[`${key}`]);
            for (let j = 0; j < colKeys.length; j++) {
              if (
                typeof user[`${key}`][`${colKeys[j]}`] === "number" &&
                colKeys[j] !== "user_id"
              ) {
                data.push(user[`${key}`][`${colKeys[j]}`]);
              }
            }
          }
        });

        if (index < 15) {
          color = customColorArray[index].color;
        } else {
          color = "#" + Math.floor(Math.random() * 16777215).toString(16);
          color = color.replace(/[^0-9A-F]/gi, ""); // remove any non-hexadecimal characters
          if (color.length < 6) {
            color += "0".repeat(6 - color.length); // add trailing zeros if necessary
          }
          color = "#" + color;
        }

        dataset.push({
          label: nameLabel,
          data: data,
          borderColor: color,
          pointHoverBackgroundColor: "#fff",
        });
      });
    }
    chartDataObj = {
      userName: userName,
      labels: convertLabelsToArrayOfArrayOfLabels(labels),
      datasets: dataset,
    };
    setChartData(chartDataObj);
  };

  const convertLabelsToArrayOfArrayOfLabels = (labelsArray) => {
    return labelsArray.map((label) => {
      if (typeof label == "string") {
        const words = label.split(" ");

        if (words.length <= MAX_WORDS_PER_LABEL) {
          return [label];
        }

        const splitLabels = [];

        for (let i = 0; i < words.length; i += MAX_WORDS_PER_LABEL) {
          splitLabels.push(words.slice(i, i + MAX_WORDS_PER_LABEL).join(" "));
        }

        return splitLabels;
      } else {
        return label;
      }
    });
  };

  const covertToDataTable = (data) => {
    const convertedDataTable = [];
    data &&
      data.forEach((val) => {
        if (typeof val === "object" && !val.user_id) {
          val["isSelected"] = false;
          convertedDataTable.push(val);
        } else {
          const valKeys = Object.keys(val);
          valKeys.forEach((key, i, arr) => {
            if (typeof val[`${key}`] === "object" && key !== "image") {
              val[`${key}`]["isSelected"] = false;
              if (!val[`${key}`]["user_id"]) {
                val[`${key}`]["user_id"] = val.user_id;
              }
              if (!val[`${key}`]["user_name"]) {
                val[`${key}`]["user_name"] = val.user_name;
              }
              convertedDataTable.push(val[`${key}`]);
            }
          });
        }
      });
    setDataTableList(convertedDataTable);
  };

  const setIntialFilters = () => {
    const allCol = props.tableColoumns;
    let obj = {};
    allCol &&
      allCol?.forEach((col) => {
        obj[`${col.column_name}`] = {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        };
      });
    setFilters(obj);
  };

  /**
   * ALL THE EVENT HANDLERS ARE PLACED HERE
   */
  const toggleSelectAll = () => {
    // If all rows are selected, deselect all.
    if (selectedUser.length === props.dataTableList.length) {
      setSelectedusers([]);
      props.selectedRow([]);
    } else {
      // If all rows are NOT selected, select all.
      setSelectedusers([...props.dataTableList]);
      props.selectedRow([...props.dataTableList]);
    }
  };

  const handleRowClick = (e, rowData) => {
    props?.setRowData(rowData);
  };

  const onSelection = (e, rowData) => {
    rowData.isSelected = e.target.checked;
    if (rowData.isSelected) {
      props.dataTableList.forEach((listVal) => {
        if (listVal.user_id === rowData.user_id) {
          setSelectedusers([...selectedUser, listVal]);
          props.selectedRow([...selectedUser, listVal]);
        }
      });
    } else {
      onUnselect(rowData);
    }
  };

  const onUnselect = (rowData) => {
    let selectedRows = [...selectedUser];
    if (selectedRows.length > 0) {
      const index = selectedRows.findIndex(
        (val) => val.user_id === rowData.user_id
      );
      selectedRows.splice(index, 1);
      setSelectedusers([...selectedRows]);
      if (!selectedRows.length) {
        props.selectedRow(null);
      } else {
        props.selectedRow([...selectedRows]);
      }
    }
  };

  function handleScreenshotClick() {
    const modal = document.querySelector("#ss-modal_content");
    const modalOverflow = modal.style.overflow;

    // Set overflow to visible to show the whole modal content
    modal.style.overflow = "visible";

    html2canvas(modal).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.download = `${reportName}_RadarChart.png`;
      link.href = imgData;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });

    // Reset overflow to its original value
    modal.style.overflow = modalOverflow;
  }

  /**
   * ALL THE UI RENDERING TEMPLATE FUNCTIONS ARE PLACED HERE
   */

  const headerClassTemplate = (header, toolTip) => {
    return (
      <>
        <Tooltip target=".tool-tip" position="top" />
        <p
          style={{ cursor: "pointer" }}
          className="tool-tip"
          placeholder={header}
          data-pr-tooltip={toolTip}
        >
          {header}{" "}
        </p>
      </>
    );
  };

  const headerTemplate = (rowData) => {
    return (
      <div>
        <label
          className="custom-checkbox"
          tab-index="0"
          aria-label="Checkbox Label"
        >
          <input
            type="checkbox"
            checked={selectedUser.some(
              (user) => user.user_id === rowData.user_id
            )}
            onChange={(e) => onSelection(e, rowData, !rowData.isSelected)}
          />
          <span className="checkmark"></span>
        </label>
        <span
          key={rowData?.user_id}
          className="image-text"
          id="pointer-class"
          onClick={(e) => handleRowClick(e, rowData)}
        >
          {rowData.user_name}
        </span>
        <span className="icon-span">ⓘ</span>
      </div>
    );
  };
  const headerBtnTemplate = () => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <span>{report}</span>
      </div>
    );
  };

  const footerForDownloadIcon = () => {
    return (
      <button className="green-download" onClick={handleScreenshotClick}>
        <i className="pi pi-download custom-dimensions"></i>
      </button>
    );
  };

  const ColBodyTemplate = (rowData) => {
    return <span>{rowData.name}</span>;
  };
  const pointTemplate = (rowData, column) => {
    const field = column.field;
    let clr = "";
    colors &&
      colors?.forEach((val) => {
        if (val.points_list.includes(rowData[`${field}`])) {
          clr = val.color;
        }
      });
    return (
      <Badge
        value={rowData[`${field}`]}
        size="large"
        severity="success"
        style={{ background: `${clr}`, color: "white" }}
      ></Badge>
    );
  };

  return (
    <div className="card">
      <DataTable
        key={locale}
        value={dataTableList}
        rowGroupMode="subheader"
        groupRowsBy="user_id"
        showGridlines
        sortMode="single"
        sortField="representative.user_name"
        sortOrder={1}
        responsiveLayout="scroll"
        rowGroupHeaderTemplate={headerTemplate}
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        filterDisplay="menu"
        rows={20}
        paginator
        filters={filters}
      >
        <Column
          field="name"
          header={() => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div className="p-checkbox">
                <label
                  className="custom-checkbox"
                  tabIndex="0"
                  aria-label="Checkbox Label"
                >
                  <input
                    type="checkbox"
                    className="p-checkbox-input"
                    checked={selectedUser.length === props.dataTableList.length}
                    onChange={toggleSelectAll}
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
              <span style={{ marginLeft: "8px" }}>Name</span>
            </div>
          )}
          body={ColBodyTemplate}
          frozen
        />

        {coloumns &&
          coloumns.map((column, index) => {
            return (
              <Column
                key={index}
                field={column.column_name}
                header={headerClassTemplate(
                  column.header_name,
                  column.tool_tip ? column.tool_tip : column.header_name
                )}
                filter
                dataType="numeric"
                body={pointTemplate}
              ></Column>
            );
          })}
      </DataTable>
      <Dialog
        id="ss-modal"
        visible={props.chartDialog}
        header={headerBtnTemplate}
        style={{ width: "1360px" }}
        modal
        className="p-fluid"
        onHide={() => props.onChartHide()}
        footer={footerForDownloadIcon}
      >
        <div className="main-dialog-flex">
          <Dialog
            className="label-dialog"
            headerClassName="label-dialog-header"
            contentClassName="label-dialog-content"
            visible={modal}
            style={{ width: "320px", borderRadius: "50px" }}
            onHide={() => setModal(false)}
          >
            <div className="padding-div">
              <p className="header-font">
                {value}{" "}
                <span style={{ color: "#000000", fontWeight: "700" }}>
                  is above Average
                </span>
              </p>
              <ul className="list-margin">
                {highScales?.map((obj, index) => {
                  return (
                    <li className="list-font" key={index}>
                      <span className="checkmark">&#x2713;</span>{" "}
                      <span>{highScales[index]}</span>{" "}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="padding-div">
              <p className="header-font">
                {value}{" "}
                <span style={{ color: "#000000", fontWeight: "700" }}>
                  is below Average
                </span>
              </p>
              <ul className="list-margin">
                {lowScales?.map((obj, index) => {
                  return (
                    <li className="list-font" key={index}>
                      <span className="crossmark">&#x2715;</span>{" "}
                      <span>{lowScales[index]}</span>{" "}
                    </li>
                  );
                })}
              </ul>
            </div>
          </Dialog>
          <div
            style={{
              margin: "20px 0",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Box width="250px" sx={{ fontFamily: "Raleway" }}>
                <TextField
                  label="Select column"
                  value={props.selectedCol}
                  select={true}
                  onChange={props.OnSelectColumn}
                  fullWidth
                  size="small"
                  color="primary"
                  inputProps={{ style: { fontSize: "14px" } }} // font size of input text
                  InputLabelProps={{ style: { fontSize: "14px" } }} // font size of input label
                >
                  {props.colList &&
                    props.colList.map((obj, index) => {
                      if (
                        !props.selectedFilterCol ||
                        props.selectedFilterColn === ""
                      ) {
                        props.selectedFilterCol = obj.title;
                      }
                      return (
                        <MenuItem key={index} value={obj.title}>
                          {obj.title}
                        </MenuItem>
                      );
                    })}
                </TextField>
              </Box>
            </div>
          </div>
          <div>
            <Chart
              type="radar"
              height="700px"
              width="700px"
              data={chartData}
              options={lightOptions}
              style={{ position: "relative" }}
            />
          </div>
          <div className="instructions-div">
            <p className="margin-class-head">How to read this Chart?</p>
            <p className="margin-class-font">4-5 Above Average</p>
            <p className="margin-class-font">1-2 Below Average</p>
            <p className="margin-class-head">
              How to get insights and recommendations?
            </p>
            <p className="margin-class-font">
              Click on each of the strengths in the graph.
            </p>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default Table;
